export * from './berichts-vorlage-delete-request.interface';
export * from './berichts-vorlage-delete-response.interface';
export * from './berichts-vorlage-delete.shapes';
